function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import { isTruthy } from "../../../utils/isTruthy";
import { ParagraphAccordion } from "./ParagraphAccordion";
import { ParagraphTwoColumnsImageText } from "./ParagraphTwoColumnsImageText";
export function ParagraphTabTeaser(props) {
    var _useState = _sliced_to_array(useState(0), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    var selectedTabContent = props.tabs.filter(isTruthy)[selectedTab];
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center py-[1.5rem] md:py-[2.5rem]"
    }, props.title && /*#__PURE__*/ React.createElement("div", {
        className: "prose container-page"
    }, /*#__PURE__*/ React.createElement("h2", null, props.title)), /*#__PURE__*/ React.createElement("nav", {
        className: "relative w-full container-page"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "md:flex w-full flex-wrap hidden items-center"
    }, props.tabs.filter(isTruthy).map(function(tab, index) {
        var _tab;
        return /*#__PURE__*/ React.createElement("li", {
            key: index,
            onClick: function() {
                setSelectedTab(index);
            },
            className: clsx("w-full relative text-center cursor-pointer hover:text-green-500 text-xl leading-lg flex justify-between items-center transition-all flex-1 whitespace-nowrap font-gill", {
                "text-green-500 border-b-[3px] border-b-green-500": index === selectedTab,
                " text-gray-500 border-b-[1.5px] border-b-black/5": index !== selectedTab
            })
        }, /*#__PURE__*/ React.createElement("button", {
            className: "text-center py-5 px-6 focus-dark flex-1"
        }, (_tab = tab) === null || _tab === void 0 ? void 0 : _tab.title));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:hidden mb-4"
    }, props.tabs.filter(isTruthy).map(function(tab, index) {
        return /*#__PURE__*/ React.createElement(ParagraphAccordion, {
            title: tab.title,
            content: [
                _object_spread({
                    __typename: "ParagraphTwoColumnsImageText"
                }, tab)
            ],
            key: index,
            titleStyle: "text-xl leading-lg",
            hideTitle: true,
            isNested: true
        });
    }))), /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait"
    }, /*#__PURE__*/ React.createElement(motion.div, {
        key: selectedTab,
        initial: {
            y: 10,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1
        },
        exit: {
            y: -10,
            opacity: 0
        },
        transition: {
            duration: 0.3
        },
        className: "md:px-12 px-0 hidden md:block"
    }, !!selectedTabContent && /*#__PURE__*/ React.createElement(ParagraphTwoColumnsImageText, selectedTabContent))));
}
